<template>
  <router-view />
</template>

<script>
export default {
  name: 'StorageProductStorageIndex'
}
</script>

